import { Col, Container, Row } from "react-bootstrap";
import "./AuthenticationLayout.css";
import Icon from "../../Icon/Icon";
import { StarFullIcon } from "../../Icon/icons";

const AuthenticationLayout = ({ children }) => {
  return (
    <Container>
      <Row className="m-4">
        <Col>
          <img className="home-logo" src="/union_icon.svg" alt="logo" />
          <span className="home-brand ms-1">Watchson</span>
        </Col>
      </Row>
      <Row className="m-4">
        <Col>{children}</Col>
        <Col className="brand-quote-container">
          <div style={{ marginBottom: "20px" }}>
            <Icon>
              <StarFullIcon fill="#fff" />
            </Icon>
            <Icon style={{ marginLeft: "10px" }}>
              <StarFullIcon fill="#fff" />
            </Icon>
            <Icon style={{ marginLeft: "10px" }}>
              <StarFullIcon fill="#fff" />
            </Icon>
            <Icon style={{ marginLeft: "10px" }}>
              <StarFullIcon fill="#fff" />
            </Icon>
            <Icon style={{ marginLeft: "10px" }}>
              <StarFullIcon fill="#fff" />
            </Icon>
          </div>
          <h1>
            Registre e <br />
            acompanhe as <br />
            suas habilidades
          </h1>
        </Col>
      </Row>
    </Container>
  );
};

export default AuthenticationLayout;
